import { Container } from '@mui/material';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import ContentLoader from '@components/ContentLoader';
import EthoraMessenger from '@components/EthoraMessenger/EthoraMessenger';
import NotFound from '@components/NotFound';

import { useMessenger } from '@hooks/useMessenger';
import { useSession } from '@hooks/useSession';

import MainWrapper from '@views/Records/Common/MainWrapper';

const messages = defineMessages({
  title: {
    id: 'messenger.title',
    defaultMessage: 'Messenger',
  },
});

/**
 * @docs https://github.com/dappros/ethora-sdk-backend-integration/blob/main/examples/healthcare-insurance/demo-frontend/src/App.tsx
 */
function Messenger() {
  const {
    state: { chatRoomId, renderChat, settings, token },
    loading,
  } = useMessenger();

  const { formatMessage } = useIntl();
  const {
    state: { isPatient },
  } = useSession();
  const title = formatMessage(messages.title);

  return (
    <ContentLoader loading={loading}>
      <MainWrapper friendlyName={title} loading={false} title={title}>
        {renderChat ? (
          <Container maxWidth="xl" sx={{ height: '75vh' }}>
            <EthoraMessenger
              chatRoomJid={chatRoomId}
              renderOneRoom={isPatient}
              settings={settings}
              token={token}
            />
          </Container>
        ) : (
          <NotFound />
        )}
      </MainWrapper>
    </ContentLoader>
  );
}

export default withErrorBoundary(Messenger, {
  FallbackComponent: (_props) => <NotFound />,
});
